/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react';
// import Icon from '@lyearn-team/frontend-components/dist/Icon';
import { ActivityIndicator, Icon as IconComponent } from '@lyearn-team/frontend-components';
import { getQueryStringVal } from 'helper/QueryString';
import { getTokensFromCode } from 'helper/refetchTokens';
import parseJWT from 'helper/parseJWT';
import cookie from 'helper/cookie';
import saveUserCookies from 'helper/saveUserCookies';
import Icon from 'helper/Icon';
import request from 'helper/NetworkLayer';
import RelayEnvironmentInit from 'components/RelayEnvironmentInit';

import CurrentUserInit from 'components/CurrentUserInit';
import UserRegistrationCheck from 'components/UserRegistrationCheck';
import { deleteCookies } from 'helper/clearUserData';

import s from './styles';

function getURLParams(urlString) {
  const queryString = urlString.split('?')[1];
  if (queryString) {
    const queryParams = queryString.split('&').reduce((params, cur) => {
      const key = cur.substring(0, cur.indexOf('='));
      const value = cur.substring(cur.indexOf('=') + 1);
      params[key] = value;
      return params;
    }, {});
    return queryParams;
  }
  return {};
}

const fetchAndSaveToken = async setFetching => {
  /* [IMP] Setting this localstorage item to check this on /UserLoginCheck, and disallow getting inside Login */
  window.localStorage.setItem('user_fmo_temp_login', true);

  setFetching(true);
  const queryParams = getURLParams(window.location.href);
  const code = queryParams.code;
  if (!code || typeof code !== 'string') {
    throw new Error('invalid code format - loginRedirect');
  }
  const subDomain =
    getQueryStringVal('cn', window.location.href) || window.location.host.split('.')[0];
  await getTokensFromCode(code, subDomain);

  const lyearn_token = cookie.get('lyearn_token');
  if (!lyearn_token) {
    throw new Error('Error in fetch authTokens response, lyearn_token not present');
  }
  const decodedToken = parseJWT(lyearn_token);
  const userId = decodedToken.user._id;

  const userResponse = await request('/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: `{user(id: "${userId}") {pid,name,companyId,picture,email,roles}}`,
      variables: '{}'
    })
  }).then(r => r.json());

  const user = userResponse.data.user;
  saveUserCookies(user.pid, user.name, user.companyId, user.email, user.picture, user.roles || []);
  setFetching(false);
  // window.location.href = isUrlSaved() ? getSavedUrl(true) : '/#/';
};

const RenderApprovalInfo = ({ companyInfo, isFMOutReachInstance }) => {
  const companyName = companyInfo ? companyInfo.name : '';

  useEffect(() => {
    if (isFMOutReachInstance) {
      setTimeout(() => deleteCookies && deleteCookies(), 200);
    }
  }, [isFMOutReachInstance]);

  return (
    <div className={s.container()}>
      <header className={s.innerPageHeader()}>
        <a href="javascript:;">
          <img
            src="https://dndw32r4edmw5.cloudfront.net/lyearn/lyearnWebsite/images/lyearn-gray-logo.png"
            alt="companyLogo"
            className={s.logoImage()}
          />
        </a>
      </header>
      <div className={s.root(isFMOutReachInstance)}>
        <div className={s.subTitle(isFMOutReachInstance)}>
          {!isFMOutReachInstance && (
            <Icon icon="check" fill="#4a90e2" size="20px" style={{ marginRight: '9px' }} />
          )}
          <div className={s.iconContainer}>
            <div className={s.checkIcon}>
              <IconComponent type="check" className={s.iconClass} />
            </div>
          </div>
          {isFMOutReachInstance
            ? `Thank you for your interest in Force Management’s Outreach Program on the Command Center. This offering is only available to our valued network of past customers, therefore your information has been submitted for verification and approval. Once approved, you will receive a ‘Welcome Email’ from no-reply@verificationemail.com. Please check your spam/junk folders if you do not see this email within one business day after registration.`
            : `We’ve sent your account for approval to ${companyName} admin. We’ll notify you once it’s approved.`}
        </div>
      </div>
      <footer className={s.innerPageFooter()}>
        <a href="/#/privacy-policy/" className={s.footerText()}>
          Privacy policy
        </a>
        <p className={s.footerText()}>
          Download Lyearn app:
          <a
            href="https://itunes.apple.com/us/app/lyearn/id1085008933"
            target="_blank"
            title="Opens in a new window"
            className={s.footerAppleIcon()}
          >
            <Icon icon="android" fill="rgba(131,146,167,0.7)" size="24px" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.lyearn.rnapp2"
            target="_blank"
            title="Opens in a new window"
            className={s.footerAndroidIcon()}
          >
            <Icon
              icon="apple"
              fill="rgba(131,146,167,0.7)"
              size="24px"
              viewBox="0 0 35.676 35.676"
            />
          </a>
        </p>
      </footer>
    </div>
  );
};

function PendingUserPage({ companyInfo }) {
  const isFMOutReachInstance =
    companyInfo.pid === '5ea82fdb315efb00085cae0f' ||
    companyInfo.pid === '56bfef41a17441a959d9c8da';
  const [fetching, setFetching] = useState(isFMOutReachInstance);

  useEffect(() => {
    if (isFMOutReachInstance) {
      fetchAndSaveToken(setFetching);
    }
  }, [isFMOutReachInstance]);

  if (fetching) {
    return <ActivityIndicator.FullScreenV2 />;
  }

  if (isFMOutReachInstance) {
    return (
      <React.Fragment>
        <RelayEnvironmentInit />
        <CurrentUserInit>
          <UserRegistrationCheck isFMOutReachInstance={isFMOutReachInstance}>
            <RenderApprovalInfo
              companyInfo={companyInfo}
              isFMOutReachInstance={isFMOutReachInstance}
            />
          </UserRegistrationCheck>
        </CurrentUserInit>
      </React.Fragment>
    );
  }
  return <RenderApprovalInfo companyInfo={companyInfo} />;

  // return (
  //   <div className={contentRoot}>
  //     <h1 className={heading}>
  //       We are currently upgrading our systems, we will be back in a few hours.
  //     </h1>
  //     <p className={text}>Apologies for the inconvenience</p>
  //   </div>
  // );
}

export default PendingUserPage;
